import React from "react";
import { Route, Routes } from "react-router-dom";
import Explore from "./marketplace/Explore";
import ProductDetails from "./marketplace/ProductDetails";
import Products from "./marketplace/Products";
import Checkout from "./marketplace/Checkout";
import Merchant from "./marketplace/Merchant";
import PayLater from "./marketplace/payment/PayLater";
import PayNow from "./marketplace/payment/PayNow";
import SelectPaymentMethod from "./marketplace/SelectPaymentMethod";
import OrderSuccess from "./marketplace/OrderSuccess";

const Marketplace = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Explore />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productId" element={<ProductDetails />} />
        <Route path="/merchants/:merchantId" element={<Merchant />} />
        <Route path="/checkout/:cartId" element={<Checkout />} />
        <Route
          path="/checkout/:sessionId/select-payment"
          element={<SelectPaymentMethod />}
        />
        <Route path="/checkout/:orderId/pay-now" element={<PayNow />} />
        <Route path="/checkout/:orderId/pay-later" element={<PayLater />} />
        <Route path="/order-success" element={<OrderSuccess />} />
      </Routes>
    </div>
  );
};

export default Marketplace;
